import { createContext, useContext, useEffect, useRef, useState } from "react";

const MusicContext = createContext(null);

// 🎙️ Ryan's "Imagine" manifesto voiceover — the opening score (placeholder until the master is ready).
const VOICE_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_wiggles-unified/artifacts/d6ibp98j_Imagine%20%281%29.m4a";

// 🎵 THE HAND-OFF: paste the final mixed "Rise Up (Andra Day x MSTR)" master here (the part where
// the beat kicks in). When the "Imagine" voiceover ends, this takes over, LOOPS, and keeps playing
// site-wide as people surf. Leave "" until the licensed/mixed file is ready.
const MUSIC_URL = "";

export function MusicProvider({ children }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(false);
  const [phase, setPhase] = useState("voice"); // "voice" -> "music"

  const src = phase === "voice" ? VOICE_URL : (MUSIC_URL || VOICE_URL);

  const start = () => {
    const a = audioRef.current;
    if (!a) return;
    a.muted = muted;
    a.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
  };
  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) { a.pause(); setPlaying(false); } else start();
  };
  const toggleMute = () => {
    const next = !muted; setMuted(next);
    if (audioRef.current) audioRef.current.muted = next;
  };

  // When the voiceover finishes, hand off to the music track (if provided) and loop it.
  const onEnded = () => {
    if (phase === "voice" && MUSIC_URL) setPhase("music");
    else setPlaying(false);
  };

  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    if (phase === "music" && playing) {
      a.loop = true;
      a.play().catch(() => {});
    }
  }, [phase]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MusicContext.Provider value={{ playing, muted, toggle, toggleMute, start, phase, hasMusic: !!MUSIC_URL }}>
      {children}
      <audio ref={audioRef} src={src} onEnded={onEnded} preload="none" />
    </MusicContext.Provider>
  );
}

export const useMusic = () => useContext(MusicContext);
